import React from "react";
import {useAppDispatch, useAppSelector} from "../../store/hooks";
import {Form} from "react-bootstrap";
import {setInfoC} from "../../store/makerDataSlice";

const CardCheckbox: React.FC = () => {

    const makerData = useAppSelector(state => state.makerData)
    const dispatch = useAppDispatch();

    if (makerData.info != 'sl') {
        return null;
    }

    return (
        <div className={'card-checkbox'}>
            <Form.Check
                type="switch"
                label="Открытка"
                id="card-checkbox"
                checked={makerData.infoC}
                onChange={(e) => {
                    dispatch(setInfoC(e.target.checked))
                }}
            />
        </div>
    )
}

export default CardCheckbox;